import { MarkChatRead } from '@mui/icons-material';
import { Avatar } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { runGenAi } from './geminiUtilities'

export default function ChatBox({ newText, loader, sendChat }) {
    const [mainHistory, setMainHistory] = useState([]);
    useEffect(() => {
        setMainHistory(JSON.parse(localStorage.getItem('mobotChatHistory')) || []);
    }, [newText])

    const messageContainerRef = useRef(null);
    useEffect(() => {
        // Scroll to the bottom when messages change
        if (messageContainerRef.current) {
            messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
        }

    }, [newText]);
    return (
        <div ref={messageContainerRef}>
            {
                Array.isArray(mainHistory) && mainHistory.map((item, index) => {
                    return <>
                        {item.role == 'model' ?
                            <div key={index + 1} className='d-flex align-items-start mb-3'>
                                <div className='me-2'>
                                    <Avatar alt={item.role} src="../images/robo.png" />
                                </div>
                                <div style={{ maxWidth: '300px', height: '100%', borderTopRightRadius: '10px', borderBottomRightRadius: '10px', borderBottomLeftRadius: '10px' }} className='p-2 shadow'>
                                    <p>{item.parts}</p>
                                    {item.lists && item.lists != 'undefined' && (
                                        Array.isArray(item.lists)
                                            ?
                                            item.lists.map((list, index) => (
                                                <>
                                                    <p className='fw-bold'> {index + 1} - {list.list_title}</p>
                                                    <hr />
                                                    <p>{list.list_description}</p>
                                                </>
                                            ))
                                            :
                                            JSON.parse(item.lists).map((list, index) => (
                                                <>
                                                    <p className='fw-bold'> {index + 1} - {list.list_title}</p>
                                                    <hr />
                                                    <p>{list.list_description}</p>
                                                </>
                                            ))
                                    )
                                    }
                                    <div>
                                        {item.prompts !== undefined &&
                                            <div>
                                                {item.prompts.map((prompt, index) => (
                                                    <button onClick={() => { sendChat('promptPress', `${prompt.title}`) }} className='btn btn-sm btn-danger me-3 mb-3' key={index}>{prompt.title}</button>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                </div>


                            </div>
                            : index != 0 &&
                            <div className='d-flex align-items-start justify-content-end mb-3' style={{ right: '', }}>

                                    <div style={{ maxWidth: '300px', height: '100%', borderTopLeftRadius: '10px', borderBottomRightRadius: '10px', borderBottomLeftRadius: '10px' }} className='p-2 bg-back text-white shadow'>
                                        <p>{item.parts}</p>
                                </div>
                                <div className='ms-2'>
                                    <Avatar alt={item.role} src="../images/robo.png" />
                                </div>
                            </div>
                        }
                    </>

                })
            }
            {
                loader && <>
                    <div className='d-flex align-items-start mb-3'>
                        <div className='me-2'>
                            <Avatar alt='MDBOT' src="../images/robo.png" />
                        </div>
                        <div style={{ width: '300px', height: '100%', borderTopRightRadius: '10px', borderBottomRightRadius: '10px', borderBottomLeftRadius: '10px' }} className='p-2 shadow'>
                            <p>Thinking ...
                            </p>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}
